import {GlobalEvent} from "@Common/react/global-event";

export const GlobalMouseMove = ({action}) => GlobalEvent({
    eventName: "mousemove",
    fn: action,
});
